Helpful = window.Helpful || {};

site.helpful = {
	init:function() {
		$('#abendingar #fieldset_noFieldset input[type=radio]').each(function() {
			$(this).parent().before(this);
		});
		$('#helpful-0').click(function(e) {
			if ($('body').width() > 992-15) {
				var scrollPosition = $(window).scrollTop() + 287;
				$("html, body").animate({scrollTop: scrollPosition}, 600);
			}
		});

		$('.close', '.helpful').on('click', function(e) {
			e.preventDefault();
			$('#fieldset_noFieldset').slideUp();
			$('#helpful-0').parent().removeClass('selected')
			Helpful.helpfulReset();
		});
	}
};

Helpful.init = function(options) {
    $('button#cancel').click(function() {
        window.history.back();
    });

    $('#helpful-1').click(function(e) {
		if (typeof options.recaptcha !== 'undefined') {
			Helpful.helpfulPostWithRecaptchaV3(options.recaptcha);
		}
		else {
			Helpful.helpfulPost(options);
		}
        $('#fieldset_noFieldset').hide();
    });
    $('#helpful-0').click(function(e) {
        $('#fieldset_noFieldset').slideDown();
        $(this).parent().addClass('selected');
        $('#fieldset_yesFieldset').addClass('open');
        $('body').addClass('helpful-open');
    });
    $('#helpful_submit').click(function(e) {
        e.preventDefault();
		if (typeof options.recaptcha !== 'undefined') {
			Helpful.helpfulPostWithRecaptchaV3(options.recaptcha);
		}
		else {
			Helpful.helpfulPost(options);
		}
    });
    $('#helpful_cancel').click(function(e) {
        $('#fieldset_noFieldset').slideUp();
        $('#helpful-0').parent().removeClass('selected');
        Helpful.helpfulReset();
    });
    $('#elm_helpful label').hover(function() {
        $(this).toggleClass('hover');
    });
    $('#fieldset_noFieldset #elm_reason .radio').click(function() {
        $('#fieldset_noFieldset #extra').focus();
        $('#fieldset_noFieldset #elm_extra label').text(options.language.explain);
    });

    $(document).mouseup(function (e) {
        var container = $("div.helpful");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('#fieldset_noFieldset').slideUp();
            $('#helpful-0').parent().removeClass('selected')
            Helpful.helpfulReset();
        }
    });
};

site.inits.push('site.helpful.init()');
